import { createReducer } from '@cld/redux-helpers';

import { CLEAR_CREDENTIALS, SET_CREDENTIALS } from '../constants/actionTypes';
import { Credentials, AuthState } from '../types';

export const initialState: AuthState = {
  cloudName: '',
  apiKey: '',
};

export default createReducer(
  {
    [SET_CREDENTIALS]: (
      state: AuthState,
      resp: {
        payload?: Credentials;
      }
    ) => ({
      ...state,
      ...resp.payload,
    }),
    [CLEAR_CREDENTIALS]: ({ cloudName, apiKey }: AuthState) => ({
      cloudName: '',
      apiKey: '',
      previousCredentials: { cloudName, apiKey }
    }),
  },
  initialState
);
